import * as types from "./mutation_types";

export default {
    [types.SET_EXTRACTABLES]: (state, { extractables }) => {
        state.extractables = extractables;
    }
};
